import React from 'react';
import EmailVerifiedRender from './EmailVerifiedRender';

export const EmailVerified = ():JSX.Element=>{

	return <EmailVerifiedRender/>;
};
